<template>
  <section class="profile-main form-section">
    <header>Основная информация</header>
    <VForm ref="form">
      <VInput
        v-model="localPartner.name"
        label="Название"
        layout="vertical"
        required
      />

      <VSelect
        v-model="localPartner.country"
        label="Страна"
        layout="vertical"
        placeholder="Введите название страны"
        data-url="countries.getList"
        option-identity="code"
        option-label="name"
        :minimum-input-length="1"
        :clearable="false"
        required
      />

      <VSelect
        v-model="localPartner.mainTimeZone"
        label="Часовой пояс головного офиса"
        layout="vertical"
        placeholder="Введите название города"
        option-label="stringRepresentation"
        :options="timeZoneOptions"
        :clearable="false"
        required
      />

      <VSelect
        ref="personTimeZoneInput"
        v-model="localUser.timeZone"
        label="Ваш часовой пояс"
        layout="vertical"
        placeholder="Введите название города"
        option-label="stringRepresentation"
        :options="timeZoneOptions"
        required
        :clearable="false"
        @update:modelValue="onUserTimeZoneUpdate"
      />
    </VForm>

    <footer>
      <VButton
        theme="primary"
        :disabled="!hasPartnerChanges && !hasUserChanges"
        @click="submit"
      >
        Сохранить
      </VButton>

      <VButton
        theme="default"
        :disabled="!hasPartnerChanges && !hasUserChanges"
        @click="revertChanges"
      >
        Отменить
      </VButton>
    </footer>
  </section>

  <br>

  <CreditLimitSection
    v-if="canShowCreditLimitSection"
    class="form-section"
    :local-partner="partner"
  />

  <br>

  <ChangePassword/>

</template>

<style lang="scss" scoped>
  .profile-main {
    footer {
      display: flex;
      justify-content: space-between;
    }
  }
</style>

<script lang="ts">

import Partner          from "@/domains/Partners/Partner";
import PartnersService  from "@/domains/Partners/PartnersService";
import TimeZone         from "@/domains/TimeZones/TimeZone";
import User             from "@/core/services/Acl/User";
import PersonsService   from "@/domains/Persons/PersonsService";
import TimeZonesService from "@/domains/TimeZones/TimeZonesService";

import ChangePassword     from "@/pages/common/ProfilePage/components/ChangePassword/ChangePassword.vue";
import CreditLimitSection from "@/domains/Partners/components/PartnerCard/PartnerEditSection/CreditLimitSection.vue";

export default defineComponent({
  components: {
    CreditLimitSection,
    ChangePassword
  },
  props: {
    partner: {
      type: Object as PropType<Partner>,
      required: true,
    },

    user: {
      type: Object as PropType<User>,
      required: true,
    }
  },

  data() {
    return {
      localPartner: this.$core.utils.cloneDeep(this.partner),
      localUser: this.$core.utils.cloneDeep(this.user),

      timeZoneOptions: [] as TimeZone[],
    }
  },

  async created() {
    await this.initTimezoneList();
  },

  computed: {
    hasPartnerChanges() {
      return !this.$core.utils.isEqual(this.partner, this.localPartner);
    },

    hasUserChanges() {
      return !this.$core.utils.isEqual(this.user, this.localUser);
    },

    canShowCreditLimitSection() {
      return this.localPartner.isBuyer && this.localPartner.isLSZ === false;
    },
  },

  methods: {
    async submit() {
      await this.$refs.form.validate();

      if (this.$refs.form.isValid === false) {
        this.$refs.form.scrollToFirstError();
      } else {
        if (this.hasPartnerChanges) {
          await PartnersService.update(this.localPartner);
        }

        if (this.hasUserChanges) {
          await PersonsService.update(this.localUser);
        }

        if (this.hasPartnerChanges || this.hasUserChanges) {
          await this.$core.acl.updateCurrentUserData();
          this.revertChanges();
        }
      }
    },

    async initTimezoneList() {
      this.timeZoneOptions = await TimeZonesService.getList();
    },

    revertChanges() {
      this.localUser = this.$core.utils.cloneDeep(this.user);
      this.localPartner = this.$core.utils.cloneDeep(this.partner);
    },

    onUserTimeZoneUpdate(timeZone: TimeZone) {
      timeZone.name = `(UTC${timeZone.UTCOffset}) ${timeZone.cities}`;

      this.localUser.timeZone = timeZone;
    },
  }

});
</script>
